import { Message } from '@raysee/schema';
import { FC, ReactNode } from 'react';
import { DecorationText } from '../../text/DecorationText';
import { useInducePop } from '../InducePopProvider';
import { Bubble, Props, Sender } from './Bubble';
import { extractUrl } from '@raysee/utility';

interface BubbleProps extends Props {
  couponMessage: Message;
  url: string;
  onClick?: (url: string, message: Message) => void;
}

export const CouponBubble2: FC<BubbleProps> = (props) => {
  const url = extractUrl(props.couponMessage.text);
  const { setOpen } = useInducePop();

  return (
    <Bubble {...props}>
      <div
        className={`rounded-2xl border drop-shadow ${props.sender ? 'bg-white' : 'bg-pink-100'}`}
      >
        <img
          src={props.message.imageUrl}
          alt={props.message.text}
          className="rounded-t-2xl object-contain"
          width={1000}
          height={750}
        />
        <div className="flex flex-col gap-1 px-4 py-2">
          <p className="text-lg font-bold">7日間限定特別クーポンをプレゼント</p>
          <p>2,999円⇒1,999円でお得に無料鑑定の続きを読みたい方はこちら↓</p>
        </div>
        <div className="flex flex-col gap-1 border-t border-t-gray-300 p-2">
          <button
            onClick={() => props.onClick(url, props.couponMessage)}
            className="py-2 text-blue-500 underline text-center"
          >
            1000円お得に続きを占う
          </button>
          <button className="py-2 text-blue-500 underline" onClick={() => setOpen(true)}>
            他の占い師も見てみる
          </button>
        </div>
      </div>
    </Bubble>
  );
};

interface TextProps {
  message: Message;
  text: string;
  children?: ReactNode;
  sender?: Sender;
  onClick?: (url: string, message: Message) => void;
}

const Paragraph: FC<TextProps> = ({ text, sender }) => (
  <span
    className={`whitespace-pre-line text-[14px] leading-[22px] ${
      sender ? 'text-gray-800' : 'text-black'
    }`}
  >
    <DecorationText text={text} />
  </span>
);

const Anker: FC<TextProps> = ({ message, text, children, onClick }) => (
  <a
    href={!onClick && text}
    onClick={onClick ? () => onClick(text, message) : undefined}
    style={{}}
  >
    {children}
  </a>
);

const replaceImage = (imageUrl: string) =>
  imageUrl.startsWith('https://page-share.line.me/@259iwyul/global/og_image.png')
    ? 'https://firebasestorage.googleapis.com/v0/b/luminous-dev.appspot.com/o/ogp%2Fline_pgp.png?alt=media&token=e3399b66-aea3-4943-b652-86ab9775593b'
    : imageUrl;
